export const adminViewActions = {
  GET_APPROVED_USERS: 'get_approved_users',
  GET_SAMBANDH_APPROVALS: 'get_sambandh_approvals',
  SHOW_HIDE_ADMIN_LOADER: 'show_hide_admin_loader'
};

export const approvalFormActions = {
  APPROVED_INVITEE_OPTIONS_LOADING_COMPLETED: 'approved_invitee_options_loading_completed',
  APPROVED_INVITEE_OPTIONS_LOADING: 'approved_invitee_options_loading',
  CLEAR_FORM_INITIAL_VALUES: 'clear_form_initial_values',
  ERROR_INITIALIZING_APPROVAL_FORM: 'error_initializing_approval_form',
  FORM_SUBMITTED: 'sampark_form_submitted',
  GET_PERMISSIONS_TO_MANAGE: 'get_permissions_to_manage',
  INITIALIZE_APPROVAL_FORM: 'initialize_approval_form',
  UPDATE_USER_ACCESS: 'update_user_access'
};

export const authActions = {
  AUTH_ERROR: 'auth_error',
  AUTH_USER_ACCESS: 'auth_user_access',
  AUTH_USER_GOOGLE: 'auth_user_google',
  AUTH_USER_SAMPARK: 'auth_user_sampark',
  UNAUTH_USER: 'unauth_user',
  REDIRECT_401: 'redirect_401'
};

export const commonActions = {
  CLOSE_DRAWER: 'close_drawer',
  CLOSE_NAV_DRAWER: 'close_nav_drawer',
  CLOSE_MODAL: 'close_modal',
  CLEAR_MODAL_COMPONENT: 'clear_modal_component',
  DISPLAY_GLOBAL_LOADER: 'display_global_loader',
  HIDE_GLOBAL_LOADER: 'hide_global_loader',
  ERROR_TOASTER: 'error_toaster',
  OPEN_DRAWER: 'open_drawer',
  OPEN_NAV_DRAWER: 'open_nav_drawer',
  OPEN_MODAL: 'open_modal',
  SEND_CONTACT_US_EMAIL: 'send_contact_us_email',
  SHOW_HIDE_TOASTER: 'show_hide_toaster',
  SUCCESS_TOASTER: 'success_toaster',
  SHOW_DEV_MODE: 'show_dev_mode'
};

export const contactActions = {
  APPEND_CONTACTS_DATA: 'append_contacts_data',
  CLEAR_SELECTED_CONTACTS: 'clear_selected_contacts',
  DOWNLOAD_CONTACT_REPORT: 'download_contact_report',
  GET_CONTACT_OPTIONS: 'get_contact_options',
  GET_CONTACTS_DATA: 'get_contacts_data',
  GET_ACTIVE_KARYAKARTAS: 'get_active_karyakartas',
  INCREMENT_CONTACTS_VIEW_CURRENT_PAGE_NUMBER: 'increment_contacts_view_current_page_number',
  RESET_CONTACTS_VIEW_CURRENT_PAGE_NUMBER: 'reset_contacts_view_current_page_number',
  SELECT_ALL_CONTACTS: 'select_all_contacts',
  SELECT_CONTACT: 'select_contact',
  SHOW_HIDE_CONTACTS_LOADER: 'show_hide_contacts_loader',
  UNSELECT_CONTACT: 'unselect_contact',
  UPDATE_CONTACTS: 'update_contacts',
  UPDATE_SEARCH_STATE: 'update_search_state',
  UPDATE_SORT_VALUE: 'update_sort_value',
  UPLOAD_CONTACT_AVATAR: 'upload_contact_avatar',
  CLEAR_FILTER_CITY_SUGGESTIONS: 'clear_filter_city_suggestions',
  GET_FILTER_CITY_SUGGESTIONS: 'get_filter_city_suggestion',
  UPDATE_CITY_FILTER_VALUE: 'update_city_filter_value',
  UPDATE_STATE_FILTER_VALUE: 'update_state_filter_value'
};

export const contactFormActions = {
  INITIALIZE_CONTACT_FORM: 'initialize_contact_form',
  INITIALIZE_READ_ONLY_CONTACT_FORM: 'initialize_read_only_contact_form',
  STORE_AVATAR_IMAGE: 'store_avatar_image',
  SUBMIT_CONTACT_FORM: 'submit_contact_form'
};

export const filterFormActions = {
  SELECT_CONTACT_FILTER_OPTION: 'select_contact_filter_option',
  UNSELECT_CONTACT_FILTER_OPTION: 'unselect_contact_filter_option'
};

export const registrationActions = {
  SIGNUP_USER: 'signup_user',
  STORE_INVITED_USER: 'store_invited_user'
};

export const sambandhApprovalActions = {
  INITIALIZE_SAMBANDH_FORM: 'initialize_sambandh_form',
  SUBMIT_SAMBANDH_APPROVAL: 'submit_sambandh_approval'
};

export const userAccessActions = {
  GET_IS_SUPER_ADMIN: 'get_is_super_admin',
  GET_USER_ACCESS_OBJECT: 'get_user_access_object',
  GET_MY_USER_ACCOUNT: 'get_my_user_account',
  GET_MY_USER_ACCOUNT_ERROR: 'get_my_user_accoun_error'
};
